import { Button, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import ViewSvg from '~/@ui/_sharedSvgs/ui/View.svg?react'
import { DeleteModal } from './DeleteModal'
import { DetailModal } from './DetailModal'
import { IUser } from '~/@api/generated-api-types/global.types'
import { useAlert } from '~/@ui/alert/useAlert'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'

type Props = {
  user: IUser | null
  reloadUser: () => void
  className?: string
}

export const Request = ({ user, reloadUser, className = '' }: Props) => {
  const { showAlert } = useAlert()

  const [isDeleteOpen, setIsDeleteOpen] = useState(false)
  const [isDetailOpen, setIsDetailOpen] = useState(false)

  const closeDelete = () => setIsDeleteOpen(false)
  const closeDetail = () => setIsDetailOpen(false)

  const pensionOrder = user?._ownerPensionOrder || null

  const deleteRequest = async () => {
    try {
      await getApi().ownerPensionOrderAppApiControllerSoftDelete(
        user?._ownerPensionOrder?.id || ''
      )

      closeDelete()
      reloadUser()
      return
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  return (
    <Stack className={`p-4 pb-4 bg-zGrey200 rounded-4d ${className}`}>
      <Stack className="flex-row justify-between items-center">
        <Typography className="text-base font-semibold text-zBlack200">
          Žiadosť o druhý dôchodok
        </Typography>
        <Stack className="h-[26px] justify-center items-center px-2 bg-[#B3A0FF] rounded-full text-xs font-semibold text-zWhite200">
          Overovanie
        </Stack>
      </Stack>

      <Stack className="flex-row justify-between pt-4">
        <Typography className="text-xs font-medium text-zGrey400">
          {`ID: ${pensionOrder?.id}`}
        </Typography>
        <Typography className="text-xs font-medium text-zGrey400">
          {new Date(pensionOrder?.createdAt || '').toLocaleDateString('sk-SK')}
        </Typography>
      </Stack>

      <Stack className="flex-row justify-between pt-2">
        <Button
          className="text-xs font-medium text-zBlack200 underline"
          onClick={() => setIsDeleteOpen(true)}>
          Zrušiť žiadosť
        </Button>
        <Button
          className="gap-2 text-3d font-bold text-zBlack200"
          onClick={() => setIsDetailOpen(true)}>
          Zobraziť
          <ViewSvg />
        </Button>
      </Stack>

      <DeleteModal
        isDeleteOpen={isDeleteOpen}
        closeDelete={closeDelete}
        deleteRequest={deleteRequest}
      />
      <DetailModal
        user={user}
        isDetailOpen={isDetailOpen}
        closeDetail={closeDetail}
      />
    </Stack>
  )
}
